<template>
  <div class="tab-table">
    <simple-table
      category="indicators"
      :columns="columns"
      :loading="loading"
      :error="error"
      :list="filteredList"
      @rowClick="rowClick"
      @fetch="handleFetch"
    />
  </div>
</template>

<script>
import SimpleTable from '@/components/common/SimpleTable';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'indicators-table',

  components: {
    SimpleTable,
  },

  data() {
    return {
      columns: [
        { label: 'Название', name: 'title', width: '25%' },
        { label: 'Тип', name: 'type', width: '15%' },
        { label: 'Описание', name: 'description', width: '55%' },
        { label: 'Изображение', name: 'image_url', width: '5%' },
      ],
    };
  },

  watch: {
    params: {
      deep: true,
      handler: function() {
        this.fetch();
      },
    },
  },

  computed: {
    ...mapGetters({
      loading: 'indicators/loading',
      params: 'indicators/params',
      error: 'indicators/error',
      list: 'indicators/list',
    }),

    filteredList() {
      return this.list.filter(
        indicator => indicator.type.title === 'Информационные'
      );
    },
  },

  methods: {
    ...mapActions({
      fetch: 'indicators/fetch',
    }),

    rowClick(id) {
      this.$router.push({
        name: `indicators-item`,
        params: {
          id,
        },
      });
    },

    handleFetch() {
      this.fetch();
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-table {
  display: flex;
  flex-direction: column;
  flex: 1;
}
</style>
